import React, { useState } from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import CartDrawer from '../components/cart/CartDrawer';
import { CONTACT_INFO } from '../data/mock';
import { HelpCircle, ChevronDown, Phone, Mail } from 'lucide-react';

const FAQPage = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "What shipping options do you offer?",
      answer: "We offer Standard Shipping ($9.95, 5-7 business days) and Express Shipping ($19.95, 2-3 business days). Orders over $99 qualify for free standard shipping. We currently ship within the United States only."
    },
    {
      question: "What is your return policy?",
      answer: "We offer a 30-day return policy for most items. Products must be unused, in original packaging, and include proof of purchase. Digital products (eBooks) are non-refundable. Contact us to initiate a return."
    },
    {
      question: "How do I track my order?",
      answer: "Once your order ships, you'll receive a confirmation email with tracking information. You can use this number to track your package on the carrier's website."
    },
    {
      question: "Are your products safe to use?",
      answer: "All our products are sourced from reputable manufacturers and meet quality standards. However, chiropractic equipment should be used as directed. If you have any medical conditions, please consult a healthcare professional before use."
    },
    {
      question: "Do you offer international shipping?",
      answer: "Currently, we only ship within the United States. We're working on expanding our shipping coverage to other regions in the future."
    },
    {
      question: "How can I contact customer support?",
      answer: `You can reach our customer support team by phone at ${CONTACT_INFO.phone} or email at ${CONTACT_INFO.email}. Our business hours are Monday-Friday 9am-6pm EST and Saturday 10am-4pm EST.`
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept all major credit cards (Visa, MasterCard, American Express, Discover) and secure payment methods. All transactions are encrypted and protected."
    },
    {
      question: "Can I cancel or modify my order?",
      answer: "Orders can be modified or canceled within 2 hours of placing them. After that, please contact us as soon as possible and we'll do our best to accommodate your request before the order ships."
    }
  ];

  return (
    <div className="min-h-screen bg-warm-50">
      <Header />
      <CartDrawer />
      
      <main className="pt-[140px] pb-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="w-16 h-16 bg-teal-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <HelpCircle className="w-8 h-8 text-teal-600" />
            </div>
            <h1 className="font-display text-display-md text-navy-900 mb-4">Frequently Asked Questions</h1>
            <p className="text-navy-500">Find answers to common questions about our products and services.</p>
          </div>

          {/* FAQ Accordion */}
          <div className="bg-white rounded-2xl shadow-card overflow-hidden mb-12">
            {faqs.map((faq, index) => (
              <div key={index} className="border-b border-warm-100 last:border-b-0">
                <button
                  onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                  className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-warm-50 transition-colors"
                >
                  <span className="font-semibold text-navy-900 pr-4">{faq.question}</span>
                  <ChevronDown 
                    className={`w-5 h-5 text-navy-500 transition-transform flex-shrink-0 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`} 
                  />
                </button>
                {openIndex === index && (
                  <div className="px-6 pb-5">
                    <p className="text-navy-600 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Contact CTA */}
          <div className="bg-navy-900 rounded-2xl p-8 text-center">
            <h3 className="font-display text-xl text-white mb-4">Still Have Questions?</h3>
            <p className="text-navy-300 mb-6">Our support team is here to help you.</p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
              <a 
                href={`tel:${CONTACT_INFO.phone.replace(/[^0-9]/g, '')}`}
                className="flex items-center gap-2 text-teal-400 hover:text-teal-300 transition-colors"
              >
                <Phone className="w-5 h-5" />
                {CONTACT_INFO.phone}
              </a>
              <a 
                href={`mailto:${CONTACT_INFO.email}`}
                className="flex items-center gap-2 text-teal-400 hover:text-teal-300 transition-colors"
              >
                <Mail className="w-5 h-5" />
                {CONTACT_INFO.email}
              </a>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default FAQPage;
